import { formatAsMoney } from '@perch-labs/warbler';
import { StyledText } from './line-items.style';

const LineItemAmount: React.FC<{ amountCents: number }> = ({ amountCents }) => (
  <StyledText>
    <strong>{formatAsMoney(amountCents, { conversion: 'fromCents' })}</strong>
  </StyledText>
);

export { LineItemAmount };
